import { render, staticRenderFns } from "./studywordsEvaluation.vue?vue&type=template&id=7ac30836&scoped=true&"
import script from "./studywordsEvaluation.vue?vue&type=script&lang=js&"
export * from "./studywordsEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./studywordsEvaluation.vue?vue&type=style&index=0&id=7ac30836&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac30836",
  null
  
)

export default component.exports